<template>
<div class="addBankDialog">
    <el-dialog title="添加库存" :visible.sync="dialogVisible" width="404px" @close="cancel">
        <el-form :model="item" :rules="rules" ref="formName" label-width="90px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="" prop="stockcount" class="">
                <div>剩余库存<span class="tc-red"> {{stockcount}}个 </span></div>
                <div class="flexstart num">追加数量<el-input v-model.trim="item.stockcount" placeholder="" clearable></el-input>个</div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="handleSure">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {uploadTredeemCodeAddStockcount, getAsseTredeemCodeInfo} from 'api/operateToolApi'
export default {
    name: 'addBankDialog',
    data() {
        return {
            dialogVisible: false,
            stockcount: '', // 剩余库存
            item: {
                codeid: '',
                stockcount: ''
            },
            rules: {
                stockcount: [
                    {required: true, message: '请输入数量', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确数字', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        handleSure() {
            this.$refs.formName.validate((valid, name) => {
                if (valid) {
                    this._edit()
                }
            })
        },
        cancel() {
            this.$refs.formName.resetFields()
            this.dialogVisible = false
        },
        openDialog(item) {
            this.item.codeid = item.codeid
            this.dialogVisible = true
            this._getStockcount()
        },
        _edit() {
            this.setLoading(true)
            uploadTredeemCodeAddStockcount ({
                data: this.item,
                success: data => {
                    this.$message.success('增加库存成功！')
                    this.cancel()
                    this.setIsRefresh(1)
                    this.$emit('refresh')
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getStockcount() {
            this.setLoading(true)
            getAsseTredeemCodeInfo ({
                data: this.item,
                success: data => {
                    this.stockcount = data.data.residuecount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setIsRefresh'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.addBankDialog {
    font-size: 14px;
    .num {
        font-size: 14px;
        margin-top: 10px;
        .el-input{
            margin: 0 10px;
        }
        .el-input,input{
            width: 98px;
            height: 32px;
            line-height: 32px;
        }
    }
    .el-dialog__body{
        padding-bottom: 10px !important;
    }
    .el-dialog__footer, .dialog-footer{
        padding: 0;
    }
}
</style>
